import { Action } from 'redux';
import { Alert, AlertScreen } from 'types/Alert';

export const ADD_ALERT = 'alerts/add_alert';
export const REMOVE_ALERT = 'alerts/remove_alert';
export const REMOVE_ALERTS_BY_SCREEN = 'alerts/remove_alerts_by_screen';
export const CLEAR_ALERT = 'alerts/clear_alert';

interface AlertAddAlertAction extends Action<typeof ADD_ALERT> {
    payload: {
        alert: Alert;
    };
}
interface AlertRemoveAlertAction extends Action<typeof REMOVE_ALERT> {
    payload: {
        uuid: string;
    };
}
interface AlertRemoveAlertsByScreenAction extends Action<typeof REMOVE_ALERTS_BY_SCREEN> {
    payload: {
        screen: AlertScreen;
    };
}

interface AlertClearAlertAction extends Action<typeof CLEAR_ALERT> {}

export type AlertsAction =
    | AlertAddAlertAction
    | AlertRemoveAlertAction
    | AlertClearAlertAction
    | AlertRemoveAlertsByScreenAction;
